module.exports = __webpack_public_path__ + "img/banner-40.1121dfb8.jpg";